

const statAge =[
  { id: '1', name: "Adult", value: "ADLT" },
  { id: '2', name: "Child", value: "CHLD" },
];

export default statAge;




// WEBPACK FOOTER //
// ./src/data/stat-age.js